import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission, SocketEvents, Api } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  User,
  Countdown,
} from 'components';
import { CleanIcon, CallIcon, WarningIcon, CommentIcon } from 'assets/icons';
import { PreparationService, GeneralService } from 'services';
import ModalLawyer from './modal-lawyer';
import ModalPayment from 'components/modal-payment';
import moment from 'moment';
import ModalComments from 'components/modal-comments';
import * as Jetemit from 'jetemit';
import { TYPES } from '../home/home';
import ModalRating from '../home/modal-rating';
import { BgProfileImage, MembershipAcquire } from 'assets/img';
import { SearchPreparation } from 'types';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  area_id: '',
  document_id: '',
  state_id: '',
  city_id: '',
};

class Preparations extends React.Component<Props> {
  timer: any = undefined;

  state = {
    form: INITIAL_STATE,
    visible: false,
    visible_payment: false,
    visible_comments: false,
    visible_lawyer: false,
    visible_rating: false,
    visible_success: false,
    // visible_confirm: modal de confirmación sin pago (Casos 2 y 3)
    visible_confirm: false,
    search: '',
    data: [],
    page: 1,
    last_page: 1,
    lawyer_page: 1,
    lawyer_last_page: 1,
    total_lawyers: 0,
    lawyers: [],
    areas: [],
    documents: [],
    states: [],
    cities: [],
    areas_loading: false,
    item: null,
    search_preparation: null as SearchPreparation | null,
    unsubscriber: () => {},
    unsubscriber2: () => {},
    timer: 0,
    plan_user: null,
    membership_service: null,
    // ACCESS_DENIED  → sin membresía → paga fee (Caso 1)
    // ACCESS_LIMITED → membresía sin usos → abogado externo sin cobro (Caso 2)
    // ACCESS_GRANTED → membresía con usos → abogado interno sin cobro (Caso 3)
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    search_preparation_status: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Elaboración documental',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.setState({
      unsubscriber: Jetemit.on(SocketEvents.SEARCH_PREPARATION.ACCEPT_LAWYER, (data: any) => {
        if (data.search_preparation?.id == this.state.search_preparation?.id) {
          this.setState({
            lawyers: data.lawyers || [],
            total_lawyers: data?.lawyers?.length,
            search_preparation: data.search_preparation,
          });
        }
      }),
      unsubscriber2: Jetemit.on(SocketEvents.SEARCH_PREPARATION.CLIENT_RESPONSE, (data: any) => {
        if (data.search_preparation?.id == this.state.search_preparation?.id) {
          if (data.status == Constants.SEARCH_PREPARATION_STATUS.WAITING_FOR_USER_RESPONSE) {
            this.setState({
              timer: data.clientTimer,
              search_preparation_status: data?.status,
              search_preparation: data?.search_preparation,
            });
          }

          if (data.status == Constants.SEARCH_PREPARATION_STATUS.FINISHED) {
            this.setState(
              {
                timer: 0,
                search_preparation: null,
                form: INITIAL_STATE,
                loading_initial: false,
                search_preparation_status: null,
                lawyers: [],
                total_lawyers: 0,
              },
              () => {
                if (this.state.visible === false && this.state.visible_payment === false) {
                  Globals.showWarning(data.message);
                }
              },
            );
          }
        }
      }),
    });

    this.load();
    this.getSelects();
    this.loadSearch();
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    // No hay auto-trigger: el usuario debe hacer clic en "Buscar".
  }

  componentWillUnmount() {
    this.state.unsubscriber();
    this.state.unsubscriber2();
  }

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  load = async (withoutLoading: boolean = false, reset: boolean = false) => {
    try {
      const res: any = await PreparationService.get({
        user_id: this.props.user?.id,
        page: this.state.page,
        search: this.state.search,
        withoutLoading,
      });

      let state: any = {
        data: res.rows,
        last_page: res.count,
        plan_user: res.plan_user,
        membership_service: res.membership_service,
        membership_status: res.membership_status,
      };

      if (reset) {
        state = {
          ...state,
          timer: 0,
          search_preparation: null,
          lawyers: [],
          total_lawyers: 0,
          form: INITIAL_STATE,
        };
      }

      this.setState(state);
    } catch (error) {}
  };

  loadSearch = async () => {
    try {
      const res: any = await PreparationService.getSearchPreparation({
        user_id: this.props.user?.id,
        status: Constants.SEARCH_PREPARATION_STATUS.IN_SEARCH,
        withoutLoading: true,
        lawyers: true,
      });

      if (!res.search_preparation) return;

      this.setState(
        {
          search_preparation: res.search_preparation,
          timer: res.timer,
          lawyers: res.lawyers,
          total_lawyers: res?.lawyers?.length,
          form: {
            area_id: res.search_preparation?.area_id?.toString(),
            document_id: res.search_preparation?.document_id?.toString(),
            state_id: res.search_preparation?.state_id?.toString(),
            city_id: res.search_preparation?.city_id?.toString(),
          },
        },
        () => {
          this.getDocuments(res.search_preparation?.area_id);
          this.getCities(res.search_preparation?.state_id);
        },
      );
    } catch (error) {
      throw error;
    }
  };

  getSelects = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      state: true,
    });

    this.setState({
      states: res.states || [],
    });
  };

  getAvailableAreas = async () => {
    const { state_id, city_id } = this.state.form;
    if (!state_id || !city_id) return;

    const params = {
      service_id: Constants.SERVICES.PREPARATION,
      lawyer_type: 'both',
      user_id: this.props.user?.id,
      state_id: Number(state_id),
      city_id: Number(city_id),
      withoutLoading: true,
    };
    console.log('[getAvailableAreas] params →', params);

    this.setState({ areas_loading: true, areas: [], documents: [] });
    try {
      const res: any = await PreparationService.getAreas(params);
      console.log('[getAvailableAreas] response →', res);
      this.setState({ areas: res.areas || [] });
    } finally {
      this.setState({ areas_loading: false });
    }
  };

  getDocuments = async (area_id: string) => {
    const { state_id, city_id } = this.state.form;

    const res: any = await Api.createResponse('app/availability/documents', {
      service_id: Constants.SERVICES.PREPARATION,
      lawyer_type: 'both',
      user_id: this.props.user?.id,
      area_id: Number(area_id),
      state_id: Number(state_id),
      city_id: Number(city_id),
      withoutLoading: true,
    });

    this.setState({ documents: res.documents || [] });
  };

  getCities = async (state_id: string) => {
    const res: any = await GeneralService.getCities({
      state_id,
      withoutLoading: true,
    });

    this.setState({ cities: res.cities || [] });
  };

  sendLawyerNotification = async () => {
    if (this.state.search_preparation) return;

    try {
      const res: any = await PreparationService.sendLawyerNotification({
        user_id: this.props.user?.id,
        area_id: this.state.form.area_id,
        document_id: this.state.form.document_id,
        state_id: this.state.form.state_id,
        city_id: this.state.form.city_id,
        page: this.state.lawyer_page,
      });

      if (res.noLawyers) {
        return Globals.showWarning('No hay abogados disponibles para esta búsqueda');
      }

      this.setState({
        search_preparation: res.search_preparation,
        timer: res.timer,
        search_preparation_status: res.search_preparation?.status,
      });
    } catch (error) {}
  };

  onLawyerClose = () => {
    this.setState({ visible: false });
  };

  onLawyerOpen = (item: any) => {
    this.setState({ visible: true, item });
  };

  onLawyerInfoOpen = (item: any) => {
    this.setState({ visible_lawyer: true, item });
  };

  onLawyerInfoClose = () => {
    this.setState({ visible_lawyer: false, item: null });
  };

  onPaymentOpen = () => {
    // --- Fee de plataforma DESACTIVADO temporalmente en elaboración documental ---
    // Antes: si el usuario no tenía membresía (Caso 1) y el abogado no tenía
    // platform_fee_exempt, se abría el modal de pago del fee (visible_payment).
    // Ahora la elaboración documental es accesible para cualquier usuario sin
    // cobro de fee, por lo que siempre se toma el camino de "Casos 2 y 3"
    // (modal de confirmación sin pago), como si el usuario tuviera membresía.
    // El backend sigue teniendo la lógica original disponible.
    //
    // const { membership_status } = this.state;
    // const item: any = this.state.item;
    // if (membership_status === Constants.ACCES_STATUS.ACCESS_DENIED && !item?.platform_fee_exempt) {
    //   this.setState({ visible_payment: true, visible: false });
    //   return;
    // }
    this.setState({ visible_confirm: true, visible: false });
  };

  onPaymentClose = (reload = false) => {
    this.setState({ visible_payment: false, visible_success: reload });
  };

  onConfirmClose = () => {
    this.setState({ visible_confirm: false });
  };

  onConfirmNoPayment = async () => {
    const item: any = this.state.item;
    try {
      await PreparationService.createNoPayment({
        user_id: this.props.user?.id,
        lawyer_id: item?.id,
        area_id: item?.area?.id,
        document_id: item?.document?.id,
        state_id: item?.state?.id,
        city_id: item?.city?.id,
        search_preparation_id: this.state.search_preparation?.id,
      });
      this.setState({ visible_confirm: false, visible_success: true });
    } catch (error: any) {
      // Antes esto se tragaba en silencio (solo console.log): el usuario no veía
      // ningún mensaje y el modal se quedaba como si no hubiese pasado nada. Ahora
      // se muestra el motivo real (ej: guardarraíl del backend, error de red, etc.)
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'No se pudo asignar el abogado';
      Globals.showError(message);
    }
  };

  onCommentsClose = (reload = false) => {
    this.setState({ visible_comments: false }, () => reload && this.load());
  };

  onCommentsOpen = (item: any) => {
    this.setState({ visible_comments: true, item });
  };

  onRatingOpen = (item: any) => {
    this.setState({ visible_rating: true, item });
  };

  onRatingClose = (reload = false) => {
    this.setState({ visible_rating: false, item: null }, () => reload && this.load());
  };

  onSuccessOpen = () => {
    this.setState({ visible_success: true });
  };

  onSuccessClose = () => {
    this.setState({ visible_success: false, item: null }, () => this.load(false, true));
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.PREPARATION_STATUS.PENDING:
        return Colors.orange;
      case Constants.PREPARATION_STATUS.FINISHED:
        return Colors.gray3;
    }
  };

  private openFacturaPdf = (relPathIn?: string) => {
    if (!relPathIn) return;

    const base = (Constants.BASE_PUBLIC || '').replace(/\/+$/, '');
    const rel = relPathIn.startsWith('/') ? relPathIn : `/${relPathIn}`;
    const url = `${base}${rel}`;

    if ((window as any).webkit?.messageHandlers?.cordova_iab) {
      const payload = { message: 'open_url', url };
      (window as any).webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(payload));
      return;
    }

    Print(url, true);
  };

  // DESACTIVADO temporalmente: handler de éxito del pago del fee de plataforma
  // en elaboración documental. Ya no se invoca porque el modal de pago
  // (ModalPayment) ya no se abre (ver onPaymentOpen), pero se deja comentado
  // para poder reactivarlo si se vuelve a habilitar el cobro del fee.
  // onSuccesPayment = async (data: any) => {
  //   const item: any = this.state.item;
  //   try {
  //     const res: any = await PreparationService.create({
  //       user_id: this.props.user?.id,
  //       lawyer_id: item?.id,
  //       area_id: item?.area?.id,
  //       document_id: item?.document?.id,
  //       state_id: item?.state?.id,
  //       city_id: item?.city?.id,
  //       service_id: Constants.SERVICES.PREPARATION,
  //       search_preparation_id: this.state.search_preparation?.id,
  //       ...data,
  //     });

  //     const relPathObjOrStr = res?.facturaPDF?.pdf?.relPath;
  //     const relPath =
  //       typeof relPathObjOrStr === 'string' ? relPathObjOrStr : relPathObjOrStr?.relPath;

  //     this.openFacturaPdf(relPath);
  //     this.onPaymentClose(true);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  loadComments = async (withoutLoading: boolean = false) => {
    const res: any = await PreparationService.viewComments({
      preparation_id: (this.state.item as any)?.id,
      withoutLoading,
    });

    return res;
  };

  sendComments = async (item: any) => {
    await PreparationService.sendComments({
      preparation_id: (this.state.item as any)?.id,
      user_id: this.props.user?.id,
      message: item.message,
      file: item.file,
      withoutLoading: true,
      hasFile: true,
    });
  };

  onExpire = () => {
    if (this.state.lawyers.length > 0) return;

    this.setState({
      timer: 0,
      search_preparation: null,
      form: INITIAL_STATE,
      loading_initial: false,
      search_preparation_status: null,
    });
    Globals.showWarning('El tiempo de respuesta ha expirado, por favor intente más tarde');
  };

  changeSearchPreparationStatus = () => {
    Globals.confirm('¿Desea cancelar la busqueda?', async () => {
      try {
        await PreparationService.changeSearchPreparationStatus({
          search_preparation_id: this.state.search_preparation?.id,
          status: Constants.SEARCH_PREPARATION_STATUS.FINISHED,
        });
        this.setState({
          timer: 0,
          search_preparation: null,
          form: INITIAL_STATE,
          loading_initial: false,
          lawyers: [],
          total_lawyers: 0,
        });
        Globals.showSuccess('La busqueda ha sido cancelada');
      } catch (error) {}
    });
  };

  render() {
    const {
      visible,
      visible_payment,
      visible_comments,
      visible_lawyer,
      visible_rating,
      visible_success,
      visible_confirm,
    } = this.state;
    const plan_user: any = this.state.plan_user;
    const search_preparation_status: any = this.state.search_preparation_status;

    return (
      <div id='client-preparation'>
        {/* Detalle del abogado antes de contratar */}
        <Modal
          className='modal-lawyer'
          visible={visible}
          title=''
          onClose={() => this.onLawyerClose()}
        >
          {/* @ts-ignore */}
          <ModalLawyer lawyer={this.state.item} action={() => this.onPaymentOpen()} />
        </Modal>

        {/* Info de abogado en elaboraciones ya creadas */}
        <Modal
          className='modal-lawyer'
          visible={visible_lawyer}
          title=''
          onClose={() => this.onLawyerInfoClose()}
        >
          {/* @ts-ignore */}
          <ModalLawyer lawyer={this.state.item} />
        </Modal>

        {/* Caso 1 (DESACTIVADO): pago del fee de plataforma en elaboración documental.
            Se comenta temporalmente: ahora el servicio es accesible sin cobro de fee
            para cualquier usuario, así que este modal ya no se abre (ver onPaymentOpen).

        <Modal
          className='modal-lawyer'
          visible={visible_payment}
          title=''
          onClose={() => this.onPaymentClose()}
        >
          <ModalPayment
            onClose={(reload: boolean) => this.onPaymentClose()}
            price={(this.state?.item as any)?.fee}
            onSuccess={(data: any) => this.onSuccesPayment(data)}
            title='Elaboración documental'
          />
        </Modal>
        */}

        {/* Casos 2 y 3: membresía activa — el pago se coordina fuera de la plataforma.
            El backend descuenta uso si los hay (Caso 3) o no descuenta si están agotados (Caso 2). */}
        <Modal
          className='modal-lawyer'
          visible={visible_confirm}
          title='Confirmar elaboración'
          onClose={() => this.onConfirmClose()}
        >
          <div style={{ padding: '16px' }}>
            <p style={{ marginBottom: '8px' }}>
              El abogado se pondrá en contacto contigo para coordinar el pago directamente.
            </p>
            {(this.state.item as any)?.lawyer_reference_price ? (
              <p style={{ marginBottom: '16px', fontWeight: 600 }}>
                Precio referencial del abogado: {(this.state.item as any).lawyer_reference_price}$
              </p>
            ) : (
              <p style={{ marginBottom: '16px', color: '#888' }}>
                El abogado te informará su precio.
              </p>
            )}
            <button
              className='btn btn-accept'
              style={{ width: '100%' }}
              onClick={() => this.onConfirmNoPayment()}
            >
              Confirmar
            </button>
          </div>
        </Modal>

        <Modal
          className='modal-comments'
          visible={visible_comments}
          title='Comentarios'
          onClose={() => this.onCommentsClose()}
        >
          {/* @ts-ignore */}
          <ModalComments
            loadComments={(withoutLoading) => this.loadComments(withoutLoading)}
            sendComments={(item) => this.sendComments(item)}
            currentUser={(this.state?.item as any)?.lawyer}
            itemId={(this.state?.item as any)?.id}
            service={Constants.SERVICES.PREPARATION}
            writeComments={
              (this.state?.item as any)?.status != Constants.PREPARATION_STATUS.FINISHED
            }
          />
        </Modal>

        <Modal
          className='modal-rating'
          visible={visible_rating}
          title='Calificar'
          onClose={() => this.onRatingClose()}
        >
          {/*
            // @ts-ignore */}
          <ModalRating
            item={this.state.item}
            type={TYPES.PREPARATION}
            onClose={() => this.onRatingClose(true)}
          />
        </Modal>

        <Modal
          className='modal-success'
          visible={visible_success}
          hideHeader={true}
          onClose={() => this.onSuccessClose()}
        >
          <div className='container-succes'>
            <div className='container-image' style={{ backgroundImage: `url(${BgProfileImage})` }}>
              <img src={MembershipAcquire} className='client-banner' />
            </div>
            <div className='body'>
              <p className='title'>Excelente</p>
              <p>Su servicio ha sido solicitidado con éxito</p>
              <p className='bold'>El abogado se pondrá en contacto con usted</p>
              <p className='close-succes' onClick={() => this.onSuccessClose()}>
                Cerrar
              </p>
            </div>
          </div>
        </Modal>

        <div className='row'>
          <div className='col-md-5'>
            <div className='row'>
              <div className='col-md-8'>
                <Input
                  value={this.state.search}
                  name='search'
                  label='Buscar'
                  placeholder='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.setState({ search: e.target.value });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <h3>Documentos creados</h3>
              </div>
              <div className='col-md-12 user-container'>
                {this.state.data?.map((i: any, index: number) => {
                  console.log(i);

                  return (
                    <div className='col-md-12' key={index}>
                      <div className='document-item'>
                        <div className='header'>
                          <small>{moment(i?.created_at).format('DD/MM/YYYY')}</small>
                          <p className='code'>ID {i?.number_format}</p>
                        </div>
                        <div className='user'>
                          <div
                            onClick={() =>
                              this.onLawyerInfoOpen({
                                id: i?.lawyer?.id,
                                area: i?.area,
                                city: i?.city?.name,
                                state: i?.state?.name,
                                document: i?.document,
                                lawyer_document_price: i?.price,
                                status: i?.status,
                                status_text: i?.status_text,
                                bank_data: i?.lawyer?.bank_data,
                              })
                            }
                          >
                            <User
                              image={i?.lawyer?.photo}
                              name={i?.lawyer?.full_name}
                              title='Abogado'
                            />
                          </div>
                          <div className='status-container'>
                            <div className='status' style={{ backgroundColor: this.getColor(i) }}>
                              <small>{i?.status_text}</small>
                            </div>
                            {i.status === Constants.PREPARATION_STATUS.FINISHED &&
                              i?.rating === null && (
                                <div
                                  className='status'
                                  style={{
                                    backgroundColor: Colors.green,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => this.onRatingOpen(i)}
                                >
                                  <small>Calificar</small>
                                </div>
                              )}
                          </div>
                        </div>
                        <p className='info'>
                          <span>{i?.document?.name}/ </span> {i?.area?.name}
                        </p>
                        <div className='footer'>
                          <p>
                            {i?.city?.name} - {i?.state?.name}
                          </p>
                          <div className='comments' onClick={() => this.onCommentsOpen(i)}>
                            <img src={CommentIcon} />
                            <p>Chatea con abogado</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <Pagination
                  pages={this.state.last_page}
                  active={this.state.page}
                  onChange={async (page: number) => {
                    await this.setState({ page });
                    this.load();
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-md-7'>
            <div className='container-search'>
              <div className='search-hint'>
                Selecciona estado, ciudad, área legal y tipo de documento para buscar un abogado
                disponible.
              </div>
              <div className='row selects'>
                <div className='col-md-3'>
                  <Select
                    disabled={this.state.search_preparation != null}
                    color='white'
                    placeholder='Seleccionar'
                    label='Ubicación (Estado)'
                    name='state_id'
                    value={this.state.form.state_id}
                    onChange={(e: any) => {
                      this.setState(
                        {
                          page: 1,
                          form: {
                            ...this.state.form,
                            state_id: e.target.value,
                            city_id: '',
                            area_id: '',
                            document_id: '',
                          },
                          cities: [],
                          areas: [],
                          documents: [],
                        },
                        () => this.getCities(e.target.value),
                      );
                    }}
                    options={this.state.states.map((item: any) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  />
                </div>
                <div className='col-md-3'>
                  <Select
                    disabled={this.state.search_preparation != null || !this.state.form.state_id}
                    color='white'
                    placeholder='Seleccionar'
                    label='Ciudad'
                    name='city_id'
                    value={this.state.form.city_id}
                    onChange={(e: any) => {
                      this.setState(
                        {
                          page: 1,
                          form: {
                            ...this.state.form,
                            city_id: e.target.value,
                            area_id: '',
                            document_id: '',
                          },
                          areas: [],
                          documents: [],
                        },
                        () => this.getAvailableAreas(),
                      );
                    }}
                    options={this.state.cities.map((item: any) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  />
                </div>
                <div className='col-md-3'>
                  <Select
                    disabled={
                      this.state.search_preparation != null ||
                      !this.state.form.state_id ||
                      !this.state.form.city_id
                    }
                    color='white'
                    placeholder={this.state.areas_loading ? 'Cargando...' : 'Seleccionar'}
                    label='Área legal'
                    name='area_id'
                    value={this.state.form.area_id}
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.getDocuments(e.target.value);
                      })
                    }
                    options={this.state.areas.map((item: any) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  />
                </div>
                <div className='col-md-3'>
                  <Select
                    disabled={
                      this.state.search_preparation != null ||
                      !this.state.form.state_id ||
                      !this.state.form.city_id ||
                      !this.state.form.area_id
                    }
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de documento'
                    name='document_id'
                    value={this.state.form.document_id}
                    onChange={(e: any) => this.change(e)}
                    options={this.state.documents.map((item: any) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 container-search-actions'>
                  {(() => {
                    const { area_id, document_id, state_id, city_id } = this.state.form;
                    const allFilled = !!(area_id && document_id && state_id && city_id);
                    return (
                      <>
                        {!this.state.search_preparation && (
                          <button
                            className='btn btn-search'
                            disabled={!allFilled}
                            onClick={() => this.sendLawyerNotification()}
                          >
                            Buscar
                          </button>
                        )}
                        {this.state.search_preparation && (
                          <>
                            {this.state.search_preparation &&
                              (this.state.search_preparation as any).status ===
                                Constants.SEARCH_PREPARATION_STATUS.IN_SEARCH && (
                                <small>Buscando abogado...</small>
                              )}
                            <button
                              className='btn btn-cancel-search'
                              onClick={() => this.changeSearchPreparationStatus()}
                            >
                              Cancelar búsqueda
                            </button>
                          </>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>
              <hr />
              <div className='container-result row'>
                <div className='col-md-12'>
                  <p className='result'>Resultado ({this.state.total_lawyers})</p>
                </div>
                <div className='col-md-12 user-container'>
                  {this.state.lawyers?.map((item: any, index: number) => {
                    const area: any = this.state.areas.find(
                      (i: any) => i.id == this.state.form.area_id,
                    );
                    const city: any = this.state.cities.find((i: any) => i.id == item?.city_id);
                    const state: any = this.state.states.find((i: any) => i.id == item?.state_id);
                    const document: any = this.state.documents.find(
                      (i: any) => i.id == this.state.form.document_id,
                    );
                    const document_price: any = item?.paper_documents?.find(
                      (i: any) => i.document_id == this.state.form.document_id,
                    );

                    return (
                      <div
                        key={index}
                        className='lawyer-item'
                        onClick={() =>
                          this.onLawyerOpen({
                            id: item?.id,
                            area,
                            city,
                            state,
                            document,
                            fee: document_price?.fee,
                            lawyer_document_price: document_price?.lawyer_document_price,
                            bank_data: item?.bank_data,
                            platform_fee_exempt: item?.platform_fee_exempt,
                          })
                        }
                      >
                        <User image={item?.photo} name={item?.full_name} title='Abogado' />
                        <div className='info'>
                          <p className='info-text'>{area?.name}</p>
                          <p>
                            {city?.name} - {state?.name}
                          </p>
                          {/* DESACTIVADO temporalmente junto con el fee de plataforma.
                          {item?.platform_fee_exempt && (
                            <span
                              style={{
                                backgroundColor: Colors.green,
                                color: '#fff',
                                borderRadius: '8px',
                                padding: '2px 6px',
                                fontSize: '10px',
                                fontWeight: 700,
                                display: 'inline-block',
                                marginTop: '4px',
                              }}
                            >
                              Sin comisión
                            </span>
                          )}
                          */}
                        </div>
                        <div className='status' style={{ backgroundColor: Colors.green }}>
                          <small>Disponible</small>
                        </div>
                        {/*
                          Fee de plataforma DESACTIVADO temporalmente en elaboración documental.
                          Antes: Caso 1 (ACCESS_DENIED, sin membresía) mostraba "Fee" + "Honorarios".
                          Casos 2 y 3 (con membresía) mostraban precio referencial del abogado con
                          aviso de pago directo. Ahora se muestra siempre esta última variante,
                          como si todos los usuarios tuvieran membresía.

                        {this.state.membership_status === Constants.ACCES_STATUS.ACCESS_DENIED && (
                          <>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <small style={{ color: '#888', fontSize: '11px' }}>Fee</small>
                              <p className='price'>{document_price?.fee}$</p>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <small style={{ color: '#888', fontSize: '11px' }}>Honorarios</small>
                              <p className='price'>
                                {document_price?.lawyer_document_price
                                  ? `${document_price.lawyer_document_price}$`
                                  : 'A convenir'}
                              </p>
                            </div>
                          </>
                        )}
                        */}
                        <div>
                          <p className='price'>
                            {document_price?.lawyer_document_price
                              ? `${document_price.lawyer_document_price}$`
                              : 'A convenir'}
                          </p>
                          <small style={{ color: '#888', fontSize: '11px' }}>
                            Pago directo con el abogado
                          </small>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Preparations);
